<template>
  <b-container class="px-4 py-5 custom-container">
    <div class="page-title pt-5 pb-3 mt-5">My Account</div>
    <b-card>
      <div class="menu-container mx-auto pb-5 w-75">
        <b-tabs
          v-model="tabIndex"
          content-class="mt-3"
          nav-class="font-weight-bold"
        >
          <b-tab
            title="Profile"
            title-link-class="nav-title"
            class="mr-5"
            @click="onClickTab(0)"
          >
            <profile-form />
          </b-tab>
          <!-- <b-tab
            title="Payments"
            title-link-class="nav-title"
            @click="onClickTab(1)"
          >
            <payment-list />
          </b-tab>
          <b-tab
            title="Payouts"
            title-link-class="nav-title"
            @click="onClickTab(2)"
          >
            <payout-details />
          </b-tab> -->
          <b-tab
            title="Account"
            title-link-class="nav-title"
            class="mr-4"
            @click="onClickTab(3)"
          >
            <account-form />
            <account-options />
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </b-container>
</template>

<script>
import ProfileForm from '@/components/forms/ProfileForm'
import PaymentList from '@/components/lists/PaymentList'
import PayoutDetails from '@/components/cards/PayoutDetails'
import AccountForm from '@/components/forms/AccountForm'
import AccountOptions from '@/components/cards/AccountOptions'

const HASHNAMES = ['#profile', '#payments', '#payouts', '#account']

export default {
  components: {
    ProfileForm,
    PaymentList,
    PayoutDetails,
    AccountForm,
    AccountOptions
  },

  data() {
    return {
      tabIndex: 0
    }
  },

  methods: {
    onClickTab(index) {
      this.$router.push({ name: 'user.settings-page', hash: HASHNAMES[index] })
    }
  },

  created() {
    this.tabIndex = HASHNAMES.indexOf(this.$route.hash)
  }
}
</script>

<style lang="scss">
.nav-title {
  padding: 10px 0;
  margin-right: 75px;
  color: grey;
  text-align: left;

  &:hover,
  &:focus {
    color: grey;
  }
}
.nav-tabs {
  border-bottom: none;

  .nav-link:hover {
    border-color: white;
  }
  .nav-link.active,
  .nav-item.show .nav-link {
    color: #2c66d5;
    border: none;
    border-bottom: 4px solid #2c66d5;
    border-radius: 0;
  }
}
.menu-container {
  padding: 0 85px;
}
@media (max-width: 1200px) {
  .menu-container {
    padding: 0 20px;
  }
}
</style>
